import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";

const parseDate = (value) => {
  if (!value) return null;

  const date = new Date(`${value}T12:00:00`);

  return Number.isNaN(date.getTime()) ? null : date;
};

const formatTradeshowDates = (startValue, endValue) => {
  const start = parseDate(startValue);
  const end = parseDate(endValue) || start;

  if (!start) return "Dates: Coming Soon";

  const startMonth = start.toLocaleString("en-US", { month: "long" });
  const endMonth = end.toLocaleString("en-US", { month: "long" });

  const startDay = start.getDate();
  const endDay = end.getDate();

  const startYear = start.getFullYear();
  const endYear = end.getFullYear();

  if (
    startDay === endDay &&
    startMonth === endMonth &&
    startYear === endYear
  ) {
    return `${startMonth} ${startDay}, ${startYear}`;
  }

  if (startMonth === endMonth && startYear === endYear) {
    return `${startMonth} ${startDay}–${endDay}, ${startYear}`;
  }

  if (startYear === endYear) {
    return `${startMonth} ${startDay} – ${endMonth} ${endDay}, ${startYear}`;
  }

  return `${startMonth} ${startDay}, ${startYear} – ${endMonth} ${endDay}, ${endYear}`;
};

const getBoothText = (booth) => {
  if (!booth?.trim()) return "Booth: Coming Soon";

  return /^booth/i.test(booth.trim())
    ? booth.trim()
    : `Booth ${booth.trim()}`;
};

function TradeshowGrid() {
  const [tradeshows, setTradeshows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadTradeshows = async () => {
      try {
        const snapshot = await getDocs(collection(db, "tradeshows"));

        const rows = snapshot.docs
          .map((docSnap) => ({
            id: docSnap.id,
            ...docSnap.data(),
          }))
          .filter(
            (show) =>
              show.active !== false &&
              show.showOnEventsPage !== false
          )
          .sort((a, b) => {
            const dateA = parseDate(a.startDate);
            const dateB = parseDate(b.startDate);

            // Shows without dates go to the bottom
            if (!dateA && !dateB) return 0;
            if (!dateA) return 1;
            if (!dateB) return -1;

            // Earliest show first
            return dateA - dateB;
          });

        setTradeshows(rows);
      } catch (error) {
        console.error("Could not load tradeshows:", error);
      } finally {
        setLoading(false);
      }
    };

    loadTradeshows();
  }, []);

  if (loading) {
    return <p>Loading events...</p>;
  }

return (
  <div className="tradeshow-showcase-grid">
    {tradeshows.map((show) => (
      <article
        className="tradeshow-showcase-card"
        key={show.id}
      >
        {/* TOP IMAGE HALF */}
        <div
          className="tradeshow-showcase-image"
          style={{
            backgroundImage: show.backgroundImageUrl
              ? `url("${show.backgroundImageUrl}")`
              : undefined,
          }}
        >
          <div className="tradeshow-showcase-dark-overlay" />

          <div className="tradeshow-showcase-top-content">

            {show.logoUrl ? (
              <img
                src={show.logoUrl}
                alt={show.name}
                className="tradeshow-showcase-logo"
              />
            ) : (
              <h3 className="tradeshow-showcase-name">
                {show.name}
              </h3>
            )}

            <div className="tradeshow-showcase-event-info">
              <span>
                {show.location || "Location Coming Soon"}
              </span>

              <span>
                {formatTradeshowDates(
                  show.startDate,
                  show.endDate
                )}
              </span>

              <span>
                {getBoothText(show.booth)}
              </span>
            </div>

          </div>
        </div>


        {/* WHITE BOTTOM HALF */}
        <div className="tradeshow-showcase-bottom">

          <p className="tradeshow-showcase-description">
            {show.heroDescription ||
              `Join Go!Foton at ${show.name}.`}
          </p>

          <a
            href={`/${show.slug || show.id}`}
            className="cta-button tradeshow-showcase-button"
          >
            View Details
          </a>

        </div>

      </article>
    ))}
  </div>
);
}

export default TradeshowGrid;